import { ControlInterface } from 'edocatbase/Form';

const { Datepicker: MuiDatePicker } = window.Edocat.Components;

import { getTimeFormat, getBooleanValue } from '../../lib/date';

interface DatePickerProps extends ControlInterface {
	readOnly: boolean;
	helperText: string;
	important: boolean;
}

export default class DatePicker extends window.React.PureComponent<DatePickerProps> {
	onFieldChange = (value: any) => {
		const { onChange, name, dirty } = this.props;
		onChange([name], value, dirty);
	};

	onBlur = () => {
		const { onBlur, name, value, dirty } = this.props;
		// @ts-ignore
		onBlur(name, value, dirty);
	};

	render() {
		const {
			label,
			disabled,
			value,
			dataType,
			control: {
				params: { showTime, minDate, dateFormat, timeFormat },
			},
			mandatory,
			name,
			className,
			placeholder,
			error,
			readOnly,
			helperText,
			important,
		} = this.props;

		let finalValue = value;
		if (value?._i === 'now') {
			finalValue = window.moment();
		} else if (value?._i?.startsWith('todayPlus')) {
			const days = value._i.match(/\d/);
			if (!isNaN(days[0])) finalValue = window.moment().add(days[0], 'days');
		}

		return readOnly || disabled ? (
			<div className={`form-row row-${name} ${readOnly ? 'simple-row' : 'read-only-row'}`}>
				<label>{label}</label>
				<div id={name}>
					{finalValue
						? window
								.moment(finalValue)
								.format(window.Edocat.Config[dataType === 'date' ? 'dateFormat' : 'dateTimeFormat'])
						: window.Alfresco.messages.global['label.none']}
				</div>
			</div>
		) : (
			<div className={`form-row row-${name}`}>
				<MuiDatePicker
					className={className}
					dataType={dataType}
					dateFormat={dateFormat}
					disabled={!readOnly && disabled}
					isClearable={!mandatory && !disabled}
					label={label}
					mandatory={!readOnly && mandatory}
					minDate={minDate}
					name={name}
					onBlur={this.onBlur}
					onChange={this.onFieldChange}
					selected={finalValue}
					showTimeSelect={getBooleanValue(showTime)}
					timeFormat={getTimeFormat(showTime, timeFormat)}
					placeholder={placeholder}
					error={error}
					readOnly={readOnly}
					helperText={helperText}
					important={important}
					id={name}
				/>
			</div>
		);
	}
}
